import * as React from 'react';
import { PropsWithChildren } from 'react';
import { AppStateContextProvider } from '@coverright/shared/contexts';
import { environment } from '../../environments/environment';
import { SnackbarProvider } from 'notistack';
import { KeycloakProvider } from '@coverright/shared/keycloak';

export const Providers = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <KeycloakProvider lateInit>
      <SnackbarProvider
        preventDuplicate
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        autoHideDuration={3000}
        maxSnack={1}
      >
        <AppStateContextProvider userFlowRestUrl={environment.userFlowRestUrl}>
          {children}
        </AppStateContextProvider>
      </SnackbarProvider>
    </KeycloakProvider>
  );
};
